<template>
  <div>
    <field-label :field="field"></field-label>
    <v-select
      :value="value"
      :items="menus"
      :menu-props="{ zIndex: 1000 }"
      :rules="rules"
      :disabled="field.disabled"
      @change="input"
      dense
      outlined
    ></v-select>
  </div>
</template>

<script>
import { activeTemplate } from '@/graphql/template.gql'
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'GoogleFontsField',
  props: ['value', 'field'],
  components: {
    FieldLabel
  },
  computed: {
    menus() {
      let menus = [
        { value: 'default', text: 'Default (based on visible pages)' }
      ]

      if (this.activeTemplate && this.activeTemplate.menus.length) {
        menus = menus.concat(
          this.activeTemplate.menus.map(menu => {
            return { value: menu.id, text: menu.name }
          })
        )
      }

      return menus
    },
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  apollo: {
    activeTemplate: {
      query: activeTemplate
    }
  },
  methods: {
    input(value) {
      this.$emit('update:value', value)
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined && this.field.default !== undefined) {
      //   this.input(this.field.default)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>